import { FormattedMessage, useIntl } from 'react-intl'
import Icon from '@mdi/react'
import { dealerConfigurePowerCyclePdu } from './pdu'

import { Circuit, SmartHardware } from 'features/home/types'
import { Cell } from 'react-table'
import { AccessMessage, StyledToggle, ToggleWrapper } from './styles'
import { messages } from './messages'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { makePublicUrl } from 'app/utils/publicUrl'
import { mdiAlert } from '@mdi/js'
import theme from 'theme_'
import { StyledErrorStateMessage } from 'components/Statuses/styles'

const powerCycleIcon = makePublicUrl('images/powerIcons/power-cycle.svg')

interface ConfirmModalType {
  homeId?: string
  cycle?: boolean
  onConfirm?: () => void
}

export const StateCell = (
  cell: Cell<Circuit>,
  homeId: string,
  setConfirmModal: (modal: ConfirmModalType) => void,
  accessEnabled: boolean
) => {
  const { formatMessage } = useIntl()
  const [updateDealerConfigurePowerCyclePdu, { status: processStatus }] =
    dealerConfigurePowerCyclePdu.useMutation()
  const onChange = () => {
    updateDealerConfigurePowerCyclePdu({
      id: homeId,
      loadName: cell.row.original.circuitName || '',
      value: cell.value === 1 ? 0 : 1,
      toggle: false,
    })
  }

  if (cell?.value === -1 || !accessEnabled) {
    return '-'
  }

  return (
    <ToggleWrapper>
      <StyledToggle
        icons={false}
        disabled={processStatus === 'pending' || cell?.value > 2}
        checked={cell?.value === 1 || cell?.value === 4}
        onChange={(e: any) =>
          setConfirmModal({ homeId, cycle: false, onConfirm: onChange })
        }
      />
      <span>
        {cell?.value === 1 || cell?.value === 4
          ? formatMessage(messages.stateOn)
          : formatMessage(messages.stateOff)}
      </span>
    </ToggleWrapper>
  )
}

export const PowerCycleCell = (
  cell: Cell<Circuit>,
  homeId: string,
  setConfirmModal: (modal: ConfirmModalType) => void,
  accessEnabled: boolean
) => {
  const [updateDealerConfigurePowerCyclePdu, { status: processStatus }] =
    dealerConfigurePowerCyclePdu.useMutation()
  const handleClick = () => {
    updateDealerConfigurePowerCyclePdu({
      id: homeId,
      loadName: cell.value,
      toggle: true,
    })
  }

  if (!accessEnabled) {
    return (
      <AccessMessage>
        <Icon path={mdiAlert} size={0.8} color={theme.colors.error} />
        <StyledErrorStateMessage>
          <FormattedMessage {...messages.noAccess} />
        </StyledErrorStateMessage>
      </AccessMessage>
    )
  }
  return (
    <CommonLinkButton
      onClick={() => {
        setConfirmModal({ homeId, cycle: true, onConfirm: handleClick })
      }}
      disabled={processStatus === 'pending'}
    >
      <img src={powerCycleIcon} alt="Power cycle" />
    </CommonLinkButton>
  )
}

export const OutletCell = (cell: Cell<SmartHardware>) => {
  if (cell.value === 5) {
    return '5, 6'
  } else if (cell.value === 6) {
    return '7, 8'
  }

  return cell.value
}
